import { gql } from '@apollo/client';

export const UPDATE_SERVICE_DEFER_RENEWAL = gql`
    mutation UpdateServiceDeferRenewal($input: UpdateServiceDeferRenewalInput!) {
        updateServiceDeferRenewal(input: $input) {
            id
            deferRenewal
            deferRenewalDate
            serviceNumber
            status
        }
    }
`;
